// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { QuestionnaireComponentOverrides } from "../../../config/QuestionnaireOverrides";
import QuestionnaireInputButtonGroup from "./QuestionnaireInputButtonGroup";
import QuestionnaireInputCheckbox from "./QuestionnaireInputCheckbox";
import QuestionnaireInputDate from "./QuestionnaireInputDate";
import QuestionnaireInputHidden from "./QuestionnaireInputHidden";
import QuestionnaireInputRadio from "./QuestionnaireInputRadio";
import QuestionnaireInputRadioButton from "./QuestionnaireInputRadioButton";
import QuestionnaireInputSelect from "./QuestionnaireInputSelect";
import QuestionnaireInputText from "./QuestionnaireInputText";
import { QuestionnaireRenderComponents } from "./QuestionnaireTypes";

export const RENDER_COMPONENTS: QuestionnaireRenderComponents = {
  text: QuestionnaireInputText,
  email: QuestionnaireInputText,
  password: QuestionnaireInputText,
  tel: QuestionnaireInputText,
  select: QuestionnaireInputSelect,
  checkbox: QuestionnaireInputCheckbox,
  buttongroup: QuestionnaireInputButtonGroup,
  radio: QuestionnaireInputRadio,
  date: QuestionnaireInputDate,
  radiobutton: QuestionnaireInputRadioButton,
  hidden: QuestionnaireInputHidden,

  ...QuestionnaireComponentOverrides,
};
